import script from "./bonusomat-quests-confirm-modal.vue?vue&type=script&lang=ts&setup=true"
export * from "./bonusomat-quests-confirm-modal.vue?vue&type=script&lang=ts&setup=true"

const __exports__ = script;

export default __exports__